import React, { useCallback, useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import './SearchWeatherStation.scss';
import { useAddAlert, useAllStations } from 'src/store/actions';
import { useStoreContext } from 'src/store/context';
import { getStations } from 'src/apis/getWeatherCalls';
import localforage from 'localforage';
import { Station } from 'src/types';
import Graphic from '@arcgis/core/Graphic';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import moment from 'moment';
import { useLocation } from 'react-router';

interface SearchStationProps {
    view: any,
}

const SearchWeatherStations: React.FC<SearchStationProps> = ({
    view,
  }) =>{
    const [state,dispatch] = useStoreContext();
	const addAlert = useAddAlert(dispatch);
    const location = useLocation(); 

    const [searchedStation, setSearchedStation] = useState<any>(null);
    const allStoredStations = useAllStations(dispatch);
    const [stationFailCount, setStationFailCount ] = useState<number>(0);

    const handleSearch=(e:React.SyntheticEvent<Element, Event>, val: any)=>{
		if(val!== null && typeof val!=='undefined'){
			const tempAllStations = state.all_stations
			const findValue = tempAllStations.filter((item)=> item.search_name === val.search_name);
			if(findValue.length>=1){
                setSearchedStation(findValue[0])
                view.goTo({
                    center: [findValue[0].longitude,findValue[0].latitude],
                    zoom: 12
                })
			}
		}
        else{
            setSearchedStation(null)
        }
	}

    /*gets the highlightsymbol*/
    const getHighlightSymbol = (layerId: string)=>{
        let symbol: any;
        if(layerId.includes('observation') || layerId.includes('obsQA_NFDR') || layerId.includes('NFDR_Missing') ){

          symbol={
            type: 'simple-marker',
            style: 'circle',
            color:[255, 222, 33, 0.75],
            size:'30px',
            outline:{
                color: [255, 222, 33],
                width: 2
            }
          }
        }
        if(layerId.includes('forecast') || layerId.includes('forecastsQA_NFDR') || layerId.includes('Forecast_Missing_NFDR')){
          symbol={
            type: 'simple-marker',
            style: 'diamond',
            color:[255, 222, 33, 0.75],
            size:'30px',
            outline:{
                color: [255, 222, 33],
                width: 2
            }
          }
        }

        if(layerId.includes('obsNotQA_NFDR')){
            symbol={
              type: 'simple-marker',
              style: 'square',
              color:[255, 222, 33, 0.75],
              size:'30px',
              outline:{
                  color: [255, 222, 33],
                  width: 2
              }
            }
        }
        if(layerId.includes('forecastNotQA_NFDR')){
            symbol={
              type: 'simple-marker',
              style: 'triangle',
              color:[255, 222, 33, 0.75],
              size:'35px',
              outline:{
                  color: [255, 222, 33],
                  width: 2
              }
            }
        }
        return symbol
      }


    /*highlight after search, needs a layer and id*/
    const addHighlight = useCallback((layer:any, id:string)=>{
        const query = layer.createQuery();
        query.where =`id = '${searchedStation.station_id}'`;
        layer.queryFeatures(query).then((result)=>{
            if(result.features.length>0){
                const highlightSymbol= new Graphic({
                    geometry: result.features[0].geometry,
                    symbol: getHighlightSymbol(result.features[0].layer.id)
                });
                let highlightLayer = new GraphicsLayer({id:id});
                highlightLayer.add(highlightSymbol);
                view.map.add(highlightLayer);
                view.map.reorder(highlightLayer, view.map.layers.length-1);
            }
        })
    } ,[view.map, searchedStation?.station_id, ])
      /* items in the useEffect will highlight after search*/
    useEffect(()=>{
        if(view.map?.layers && searchedStation!==null){
            //need a listener to see when layers has changed
            const listener = view.map.layers.on('change',(event)=>[
                event.added.forEach((layer)=>{
                    if(layer.id.includes('&Zoom=5') && layer.id.includes(state.selectedElement?.value)){
                        if(state.selectedRadio.type ==='hourly'&& layer.id.includes(`&StartDate=${moment(state.dates[0]).utc().format()}`)&& layer.id.includes(`&EndDate=${moment(state.dates[1]).utc().format()}`)){
                            const stringHourly = `highlightLayer-${searchedStation.station_id}-${state.selectedElement?.value}-${moment(state.dates[0]).utc().format()}-${moment(state.dates[1]).utc().format()}`;
                            addHighlight(layer, stringHourly)
                        }
                        if(state.selectedRadio.type==='daily' && layer.id.includes(`&StartDate=${moment(state.dates[0]).utc().format('YYYY-MM-DD')}`)&& layer.id.includes(`&EndDate=${moment(state.dates[1]).utc().format('YYYY-MM-DD')}`)){
                            const stringWxDaily = `highlightLayer-${searchedStation.station_id}-${state.selectedElement?.value}-${moment(state.dates[0]).utc().format('YYYY-MM-DD')}-${moment(state.dates[1]).utc().format('YYYY-MM-DD')}`
                            addHighlight(layer, stringWxDaily)
                        }
                    }
                })
            ]);

            view.map.layers?.forEach((layer)=>{
                if(layer.id.includes('&Zoom=5') && layer.id.includes(state.selectedElement?.value)){
                    if(state.selectedRadio.type ==='hourly'&& layer.id.includes(`&StartDate=${moment(state.dates[0]).utc().format()}`)&& layer.id.includes(`&EndDate=${moment(state.dates[1]).utc().format()}`)){
                        const stringHourly = `highlightLayer-${searchedStation.station_id}-${state.selectedElement?.value}-${moment(state.dates[0]).utc().format()}-${moment(state.dates[1]).utc().format()}`;
                        addHighlight(layer, stringHourly)
                    }
                    if(state.selectedRadio.type==='daily' && layer.id.includes(`&StartDate=${moment(state.dates[0]).utc().format('YYYY-MM-DD')}`)&& layer.id.includes(`&EndDate=${moment(state.dates[1]).utc().format('YYYY-MM-DD')}`)){
                        const stringWxDaily = `highlightLayer-${searchedStation.station_id}-${state.selectedElement?.value}-${moment(state.dates[0]).utc().format('YYYY-MM-DD')}-${moment(state.dates[1]).utc().format('YYYY-MM-DD')}`
                        addHighlight(layer, stringWxDaily)
                    }
                }

            })
            return()=>{
                listener.remove();
            }

        }
    },[view.map.layers, searchedStation, view.graphics,state.dates, state.selectedElement?.value, state.selectedRadio.type, view.map, addHighlight])

    useEffect(()=>{
        //below removes layer
        if( view.map?.layers){
            let uniqueIdCount = 0;
            view.map.layers?.forEach((layer)=>{
                if(layer.id.includes('highlightLayer')){
                    if(searchedStation){
                        if( state.selectedRadio.type ==='hourly' && layer.id !== (`highlightLayer-${searchedStation.station_id}-${state.selectedElement?.value}-${state.selectedElement?.value}-${moment(state.dates[0]).utc().format()}-${moment(state.dates[1]).utc().format()}`)){
                            view.map.remove(layer);
                        }
                        else if( state.selectedRadio.type ==='daily' && layer.id !== (`highlightLayer-${searchedStation.station_id}-${state.selectedElement?.value}-${state.selectedElement?.value}-${moment(state.dates[0]).utc().format('YYYY-MM-DD')}-${moment(state.dates[1]).utc().format('YYYY-MM-DD')}`)){
                            view.map.remove(layer);
                        }
                        else{
                            uniqueIdCount= uniqueIdCount+1;
                            if(uniqueIdCount>1){
                                view.map.remove(layer);
                            }
                        }
                    }
                    else{
                        view.map.remove(layer);
                    }
                }

            })
        }
    },[searchedStation, view.map, state.selectedElement?.value, state.dates, state.selectedRadio.type])

    const stationCallback = useCallback((counter:number) =>{
		(async()=>{
			try{
				const varRequest = {
                    returnAll: true,
				};
				const response: any = await getStations(varRequest, addAlert, state?.user);
				if(response){
                    const stations = response.stations.sort(function(a:any, b:any) {
                        return a.search_name.localeCompare(b.search_name);
                     })
                    allStoredStations(stations);
                    setStationFailCount(0)
				}
			}
			catch(error){
                console.log('error', error);
                setStationFailCount(counter+1)
			}
		})();
	},[addAlert, allStoredStations, setStationFailCount, state?.user]);
	

    useEffect(() => {
        if (state.all_stations?.length < 1) {
            localforage.getItem('allStations').then(async function (stations) {
                let allStations = stations as Station[];
                if (!allStations) {
                    stationCallback(stationFailCount);
                }
                else {
                    allStoredStations(allStations);
                }
            })

        }
    }, [state.all_stations?.length, allStoredStations, stationCallback, stationFailCount]);

    useEffect(()=>{
        if(stationFailCount>0 && stationFailCount<4){
            stationCallback(stationFailCount);
        }
    },[stationCallback, stationFailCount])

    /*this useEffect will check to see if there is a station id available in the location.search*/
    useEffect(()=>{
        if(location?.search && state.all_stations?.length>1){
            const stringArray = decodeURIComponent(location.search).split("/");
            view.when(()=>{
                Promise.all(view.map.layers.map(layer=>view.whenLayerView(layer))).then(async()=>{
                    try{
                        if(stringArray?.length===10){
                            const found = state.all_stations.find((station)=>station.station_id===Number(stringArray[9]))
                            if(found){
                                setSearchedStation(found)
                                await view.goTo({
                                    center: [found.longitude, found.latitude],
                                    zoom: 12
                                })
                            }
                        }
                    }
                    catch(error){
                        console.log('error', error)
                        console.warn('Go to interrupted')
                    }
                })
            })
        }
    },[location?.search, state.all_stations, view])

    useEffect(()=>{

    },[state.alerts])

    return(
        <div className={state.alerts?.filter((a)=>a.type==='warning')?.length>0?'searchStationsContainer-warning-present':'searchStationsContainer-closed'}>
            <i className="fas fa-search" style={{ paddingLeft: '5px' }} />
            <Autocomplete
                noOptionsText={
                    <div className='no-results'>
                        <div>No results match your search criteria.</div>
                        <div><b>Here are a few tips:</b></div>
                        <div>• Remember to check your spelling<br />
                            • Ensure you are searching either a Station Name or Station ID number</div>
                    </div>
                }
                onChange={(e, value) => handleSearch(e,value)}
                options={state.all_stations}
                getOptionLabel={(option)=>`${option.search_name}`}
                filterOptions={(options, {inputValue})=>{
                    const search = inputValue.toLowerCase();
                    if(search.length<=2){
                        return options.filter((option)=>
                            option.state?.toLowerCase().includes(search) ||
                            option.station_id.toString().includes(search)
                        )
                    }
                    return options.filter((option)=>
                        option.station_name?.toLowerCase().includes(search) ||
                        option.network_name?.toLowerCase().includes(search) ||
                        option.state?.toLowerCase().includes(search) ||
                        option.station_id.toString().includes(search)
                    )
                }}
                renderInput={(params) => (
                    <TextField
                        data-testid={'search-bar'}
                        aria-label={'Search Station...'}
                        {...params}
                        label="Search Station..."
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                    />
                )}
            />
        </div>
    )
}

export default SearchWeatherStations;
